import React from "react";
import { Modal, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {  checkoutAsset } from "../../../Slices/assetSlice";
import { SelectInput } from "../../../blueplanitUtils/InputField";

const AddMaintenanceModal = ({ open, onClose, assets, availableAssetIds, selectedAssetTagId, setSelectedAssetTagId, onSuccess }) => {

  const loginUser = useSelector(
    (state) => state?.loginUserInfo?.loginUserDetails
  );
  const dispatch = useDispatch();

  
  const handleSubmit = async () => {
  if (!selectedAssetTagId) {
    message.error("Please select all fields.");
    return;
  }

  const assetToAdd = assets.find(
    (asset) => asset.assetTagId === selectedAssetTagId
  );
  if (!assetToAdd) {
    message.error("Selected asset not found.");
    return;
  }  

  try {
    await dispatch(
      checkoutAsset({
        id: assetToAdd.id,
        productName: assetToAdd.productName,
        checkedOutBy: `${loginUser?.firstname} ${loginUser?.lastname}` || "Unknown",
        checkOutReason: "Added via Maintenance",
        suppressCheckInStatus: true,
        isManuallyAddedToMaintenance: true,
        expectedCheckInDate: null,
      })
    );

    message.success("Asset added for maintenance.");
    if (onSuccess) onSuccess();
    onClose();
    setSelectedAssetTagId(null);
  } catch (error) {
    message.error("Failed to add asset.");
  }
};


  return (
    <Modal
      title="Add Maintenance"
      open={open}
      onCancel={onClose}
      onOk={handleSubmit}
      okText="Submit"
    >
      <div style={{ marginBottom: 16 }}>
        <label style={{ display: "block", marginBottom: 4 }}>
          Asset Tag ID
        </label>
        <SelectInput
          placeholder="Select Asset ID"
          style={{ width: "100%" }}
          labelInValue
          value={
            selectedAssetTagId
              ? { label: selectedAssetTagId, value: selectedAssetTagId }
              : undefined
          }
          onChange={(value) => setSelectedAssetTagId(value)}
          options={availableAssetIds.map((asset) => ({
            value: asset.assetTagId,
          }))}
        />
      </div>
    </Modal>
  );
};

export default AddMaintenanceModal;
